<template>
	<div class="get_face">
		<document-title-bar :pathData="isPathData"></document-title-bar>
		<h1 class="doc_main_h1">设置人证比对阈值</h1>
		<h3 class="doc_main_h3">功能描述</h3>
		<p class="doc_main_p">
			根据需求设置人证比对阈值，值越大比对越严格，建议使用默认值（不设置即可）。
		</p>
		<h3 class="doc_main_h3">函数</h3>
		<pre class="doc_main_pre"><code class="doc_main_code">bool __stdcall SKFaceSetIDCompareThreshold(int nThreshold);</code></pre>
        <h3 class="doc_main_h3">参数</h3>
        <p class="doc_main_p">nThreshold：阈值，范围50-100, int类型</p>
        <h3 class="doc_main_h3">返回值</h3>
        <p class="doc_main_p">bool类型，true表示成功，false表示失败</p>
		<h3 class="doc_main_h3">示例代码</h3>
		<pre class="doc_main_pre"><code class="doc_main_code">bool bRet = SKFaceSetIDCompareThreshold(80);</code></pre>
	</div>
</template>
<script>
	import DocumentTitleBar from '../../../../components/documentTitleBar';
	export default{
		components:{
			'document-title-bar':DocumentTitleBar,
		},
		data(){
			return{
				isPathData:['人脸识别','SKFaceLive-Windows','基础接口','设置人证比对阈值'],
			}
		},
		watch:{

		},
		methods:{

		},
		mounted(){

		}
	}
</script>
<style lang="less" rel="stylesheet/less">
	@import '../../../../less/index.less';
	.get_face{
	}
</style>	



// WEBPACK FOOTER //
// src/views/documents/skfacelivewindows/basics/setPersonAndCard.vue